import { mapStrings, stringsTuple } from 'utils/strings/mapStrings';

const httpMethodsTuple = stringsTuple('get', 'put', 'post', 'delete', 'patch');
export type IHttpMethod = typeof httpMethodsTuple[number];
export const hm = mapStrings<IHttpMethod>(httpMethodsTuple);
